import React from 'react';
import styled from 'styled-components';
import Styles from '../CartItem/CartItem.styles';
import Text from '../Text';
import icoParking from '../../compound/TicketsWhite/Assets/ico_parking.svg';
import ParkingSpotError from '../../compound/ParkingSpotError';
import editIcon from '../../compound/TicketsWhite/Assets/ico_edit.svg';
import deleteIcon from '../../compound/TicketsWhite/Assets/ico_delete.svg';

const Container = styled.div`${Styles.cartTicketsListItem}`;
const Icon = styled.img`${Styles.cartTicketsListItemIcon}`;
const InfoWrapper = styled.div`${Styles.cartTicketsListItemInfoWrapper}`;
const Product = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.cartTicketsListItemProduct}`;
const ActionIcon = styled.img`${Styles.cartTicketsListItemDelete}`;
const Label = styled(Text).attrs({ bold: true })`${Styles.cartTicketsListItemInfoLabel}`;
const InfoText = styled(Text)`${Styles.cartTicketsListItemInfoText}`;
const Row = styled.div`${Styles.cartTicketsListItemInfoRow}`;
const Column = styled.div`${Styles.cartTicketsListItemInfoCol}`;
// eslint-disable-next-line require-jsdoc

const CartItemParking = ({
  product,
  index,
  locale,
  strings,
  editFn,
  deleteFn
}) => {
  let editBtn = <></>;
  if(editFn) {
    editBtn = <ActionIcon
    onClick={() => {
      editFn(index);
    }}
    src={editIcon}
    style={{ marginRight: 10 }}/>
  }
  let deleteBtn = <></>;
  if(deleteFn) {
    deleteBtn = <ActionIcon
    onClick={() => {
      deleteFn(index);
      window.localStorage.setItem('currentFlow', 'Parking');
    }}
    src={deleteIcon} />
  }
  
  let Item = <></>;
  const hasIssue = product.hasOwnProperty('noAvailability');
  Item = (
    <Container style={{
      backgroundColor: hasIssue ? 'rgba(255, 0, 0, 0.1)' : '#FFFFFF',
      borderBottomColor: hasIssue ? '#E05C96' : '#D8D8D8',
    }}
    >
      <Icon src={icoParking} />
      <InfoWrapper>
        <Row style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Product style={{ flex: 4 }}>{`1 ${locale === 'es' ? 'boleto' : 'ticket'} ${locale === 'es' ? `Estacionamiento en lote ${product.location}` : `Parking in ${product.location}`}`}</Product>
          <Product style={{ flex: 1, textAlign: 'end', flexDirection: 'column' }}>
            <span>{`$${(product.customer_paid).toFixed(2)}`}&nbsp;USD</span>
          </Product>
        </Row>
        <Row>
          <Column style={{ flex: 2 }}>
            <Row style={{ alignItems: 'flex-start' }}>
              <Label>{`${locale === 'es' ? 'Del' : 'From'}: `}</Label>
              <InfoText>{` ${product.start_time.replace('T', ' @ ').substring(0, 18)}`}</InfoText>
            </Row>
            <Row style={{ alignItems: 'flex-start' }}>
              <Label>{`${locale === 'es' ? 'Al' : 'To'}: `}</Label>
              <InfoText>{` ${product.end_time.replace('T', ' @ ').substring(0, 18)}`}</InfoText>
            </Row>
          </Column>
          <Column style={{ flex: 2, alignSelf: 'flex-start' }}>
            <Row style={{ alignItems: 'flex-start' }}>
              <Label>{`${locale === 'es' ? 'Vehículo' : 'Vehicle'}:`}</Label>
              <InfoText>{` ${product.vehicleDescription}`}</InfoText>
            </Row>
            <Row>
              <Label>{`${strings.license}:`}</Label>
              <InfoText> {product.vehicleLicense || ''} - {product.state || ''}</InfoText>
            </Row>
          </Column>
          <Column style={{ flex: 1, marginRight: 0 }}>
            <Row style={{ justifyContent: 'end' }}>
              {editBtn}
              {deleteBtn}
            </Row>
          </Column>
        </Row>
      </InfoWrapper>
      <ParkingSpotError foundSpot={hasIssue} locale={locale} />
    </Container>);
  return Item;
};

export default CartItemParking;
